// AI Generated Service
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class ComplianceDataPrivacyService {
    dataPrivacyCompliance (summary: { compliance_percentage: number }): number[] {
        const percentage = this.dataPrivacyCompliancePercentage(summary);
        return [percentage, 100 - percentage];
    }

    dataPrivacyCompliancePercentage (summary: { compliance_percentage: number }): number {
        return summary.compliance_percentage || 0;
    }
}
